var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dag } from "@hyper-hyper-space/hhs3_dag";
import { json } from "@hyper-hyper-space/hhs3_json";
import { validationFailure, validationOk } from "./validation.js";
export const MAX_TYPE_LENGTH = 128;
export const emptyVersion = dag.emptyPosition;
export const version = dag.position;
// Format for the MVT type id on a genesis create payload. Each type's
// create*Format should pin this to a constant for that type id.
export function createPayloadTypeFormat(typeId) {
    return [json.Type.Constant, typeId];
}
export function createPayloadTypeFieldFormat() {
    return [json.Type.BoundedString, MAX_TYPE_LENGTH];
}
export function extractCreatePayloadType(payload) {
    if (payload === null || typeof payload !== 'object' || Array.isArray(payload)) {
        return undefined;
    }
    const p = payload;
    if (p['action'] !== 'create')
        return undefined;
    const type = p['type'];
    return typeof type === 'string' ? type : undefined;
}
export function validateCreatePayloadType(payload, expectedTypeId) {
    return extractCreatePayloadType(payload) === expectedTypeId
        ? validationOk()
        : validationFailure(`create payload type is not '${expectedTypeId}'`);
}
export class TypeRegistryMap {
    constructor() {
        this.types = new Map();
    }
    register(typeName, factory) {
        this.types.set(typeName, factory);
    }
    has(typeName) {
        return this.types.has(typeName);
    }
    lookup(typeName) {
        return __awaiter(this, void 0, void 0, function* () {
            const factory = this.types.get(typeName);
            if (factory === undefined) {
                throw new Error(`Type '${typeName}' not found in registry`);
            }
            return factory;
        });
    }
}
